// extracted by mini-css-extract-plugin
export default {"baseLayout":"styles_base-layout__efL63","baseLayout__aside":"styles_base-layout__aside__aff8Y","baseLayout__main":"styles_base-layout__main__jQCVs"};